import type { Theme } from '@mui/material';

export const styles = {
  title: {
    flexShrink: 1,
    overflow: 'hidden',
  },

  selectedLanguage: (theme: Theme) => ({
    color: theme.colors.neutral[400],
  }),
};
